import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link } from 'react-router-dom';

export default function CustomCarousel({
  swiperContent = [
    {
      heading: 'Explore Our Provider Network',
      description: 'Simple & convinient process',
      imgUrl: '/images/doctor.png',
      buttonText: 'Learn more',
      href: '#',
    },
  ],
}) {
  const slider = React.useRef(null);
  const [activeSlide, setActiveSlide] = useState(0);

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (_, next) => setActiveSlide(next),
  };

  return (
    <div className="relative">
      <Slider ref={slider} {...settings}>
        {swiperContent?.map((ele, index) => (
          <div className="relative" key={index}>
            <img
              src={ele?.imgUrl}
              className="w-full object-cover object-top"
              alt="Slide 1"
            />
            <div className="absolute top-1 md:top-10 text-center w-full text-3xl sm:text-5xl lg:top-10 text-10 tracking-normal font-halyard font-normal text-white capitalize ">
              {ele?.heading}
            </div>
            <div
              key={activeSlide === index ? 'active' : 'inactive'}
              className={`absolute h-full top-10 w-full bg-black bg-opacity-10  flex flex-col justify-center items-center  ${
                activeSlide === index ? 'animate-fadeInDown' : ' '
              }`}
            >
              <div className="sm:text-md lg:text-midLg font-dm-sans font-medium text-white hidden md:block md:!pt-7.5 md:pb-5 capitalize">
                {ele?.description}
              </div>
              <Link to={ele.href || '/'}>
                <div className="mt-28 md:mt-3.5 sm:mt-0 text-xs text-white font-normal w-fit !py-2 !px-3 lg:!py-3.5 whitespace-nowrap lg:!px-10 text-center uppercase leading-7 tracking-0.5px !bg-midGreen font-halyard">
                  {ele?.buttonText}
                </div>
              </Link>
            </div>
          </div>
        ))}
      </Slider>
      <div
        onClick={() => slider?.current?.slickPrev()}
        className="absolute top-[45%] left-0 md:mx-14 bg-disableGray sm:p-2 md:p-3 tab:!p-5 w-fit h-fit cursor-pointer hidden lg:block "
      >
        <img src="/images/arrow.svg" className="h-6" alt="arrow icon" />
      </div>
      <div
        className="absolute top-[45%] right-0 md:mx-14 bg-disableGray  tab:!p-5 md:p-3 w-fit h-fit cursor-pointer hidden lg:block "
        onClick={() => slider?.current?.slickNext()}
      >
        <img
          src="/images/arrow.svg"
          className="h-6 rotate-180"
          alt="arrow icon"
        />
      </div>
    </div>
  );
}
